import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
  Alert,
  PanResponder,
  Animated,
} from "react-native";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import draggableHelpers from "app/utils/draggableHelpers";
import chapterActions from "app/utils/chapterActions";
import momentActions from "app/utils/momentActions";
import valueActions from "app/utils/valueActions";

import store from "app/redux/store";

const DISABLED = true;
// const DISABLED = !ENV.WEB;

export default class Draggable extends React.Component {
  static propTypes = {
    onPress: PropTypes.func,
    dragThreshold: PropTypes.number,
    shelfThreshold: PropTypes.number,
    onShelf: PropTypes.func,
    flex: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    dragThreshold: 5,
  };

  constructor(props) {
    super(props);
    this.state = {
      pan: new Animated.ValueXY(),
      panResponder: null,
      startingX: 0,
      startingY: 0,
      x: null,
      y: null,
      isDragging: false,
    };
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.freezeOnRelease && !this.props.freezeOnRelease) {
      if (!this.state.isDragging) {
        // reset to home
        Animated.spring(this.state.pan, {
          toValue: { x: 0, y: 0 },
          friction: 10,
          useNativeDriver: !ENV.WEB,
        }).start();
      }
    }
  }

  async componentDidMount() {
    if (DISABLED || this.props.disabled) return;
    let { onPress, dragThreshold, onDragStart } = this.props;
    // this.pan = new Animated.ValueXY()
    let panResponder = PanResponder.create({
      // Ask to be the responder:
      onStartShouldSetPanResponder: (evt, gestureState) => {
        return true;
        // return !(gestureState.dx === 0 && gestureState.dy === 0)
      },
      onStartShouldSetPanResponderCapture: (evt, gestureState) => {
        console.log(
          "onStartShouldSetPanResponderCapture",
          !(gestureState.dx === 0 && gestureState.dy === 0),
        );
        return !(gestureState.dx === 0 && gestureState.dy === 0);
        // return true;
      },
      onMoveShouldSetPanResponder: (evt, gestureState) => {
        // return true
        // console.warn('onMoveShouldSetPanResponder', (Math.abs(gestureState.dx) > dragThreshold || Math.abs(gestureState.dy) > dragThreshold))
        if (
          Math.abs(gestureState.dx) > dragThreshold ||
          Math.abs(gestureState.dy) > dragThreshold
        ) {
          console.log("set dragging true...1");
          this.setState({ isDragging: true });
          // this doesnt seem to fire
          this.props.onDragStart && this.props.onDragStart();
          return true;
        }
        return false;
        // return !(gestureState.dx === 0 && gestureState.dy === 0)
      },
      onMoveShouldSetPanResponderCapture: (evt, gestureState) => {
        // return true
        if (
          Math.abs(gestureState.dx) > dragThreshold ||
          Math.abs(gestureState.dy) > dragThreshold
        ) {
          console.log("set dragging true...2");
          this.setState({ isDragging: true });
          // this one fires!!
          // (no it doesnt...?)
          this.props.onDragStart && this.props.onDragStart();
          // if (this.props.global) {
          //   // store.dispatch({ type: "dragging/start", coords });
          // }
          return true;
        } else return false;
        // return !(gestureState.dx === 0 && gestureState.dy === 0)
      },
      onPanResponderGrant: (evt, gestureState) => {
        let { moveX, moveY, x0, y0 } = gestureState;
        console.log(moveX, moveY, x0, y0, gestureState);
        this.setState({ startingX: moveX, startingY: moveY });
        if (this.props.global) {
          this.handleGlobalStart({ x: moveX, y: moveY });
        }

        // others not firing, so put it here?
        this.props.onDragStart && this.props.onDragStart();

        // gestureState.d{x,y} will be set to zero now
        this.state.pan.setOffset(this.state.pan.__getValue());
        // this.state.pan.setOffset({
        //   x: this.state.pan.x._value,
        //   y: this.state.pan.y._value
        // });
        this.state.pan.setValue({ x: 0, y: 0 });
      },
      onPanResponderMove: (evt, gestureState) => {
        // The most recent move distance is gestureState.move{X,Y}
        // The accumulated gesture distance since becoming responder is
        // gestureState.d{x,y}
        // console.log(this.state.pan.y._value)
        // console.log(evt)
        // console.log(gestureState.dy, gestureState.moveY, gestureState.y0)
        Animated.event(
          [
            null,
            {
              dx: this.state.pan.x,
              dy: this.state.pan.y,
            },
          ],
          { useNativeDriver: false },
        )(evt, gestureState); // <<--- INVOKING HERE!

        let { moveX, moveY, x0, y0, dx, dy } = gestureState;
        // this.props.onDragEnd && this.props.onDragEnd({x: moveX, y: moveY})
        let coords = { x: moveX, y: moveY };
        this.props.onDragMove && this.props.onDragMove(coords);

        if (this.props.global) {
          this.handleGlobalMove(coords);
        }
      },
      onPanResponderTerminationRequest: (evt, gestureState) => {
        console.log("onPanResponderTerminationRequest", evt);
        return false;
      },
      onPanResponderRelease: (evt, gestureState) => {
        let { dragging } = store.getState();
        // The user has released all touches while this view is the
        // responder. This typically means a gesture has succeeded
        let { moveX, moveY, x0, y0, dx, dy, vx, vy } = gestureState;
        console.log("release:", dx, dy);
        // let { startingX, startingY, } = this.state
        console.log("started at:", x0, y0);

        console.log("VELOCITY", vx, vy);
        if (vx > 0.5 || vy > 0.5) {
          if (this.props.onToss) {
            console.log("TOSS!!!");
            this.props.onToss();
          }
        }

        // console.warn(Math.abs(dx), Math.abs(dy), dragThreshold)
        if (
          !!onPress &&
          Math.abs(dx) < dragThreshold &&
          Math.abs(dy) < dragThreshold
        ) {
          onPress();
        }

        // console.warn(moveY, this.props.shelfThreshold)

        if (!!this.props.shelfThreshold && moveY > this.props.shelfThreshold) {
          this.props.onShelf && this.props.onShelf();
        }

        if (
          !!this.props.yThreshold &&
          gestureState.moveY < this.props.yThreshold
        ) {
          this.state.pan.flattenOffset();
        } else if (!!this.props.freezeOnRelease || dragging.metaKey) {
          this.state.pan.flattenOffset();
        }
        // else if(!!this.props.shelfThreshold && moveY > this.props.shelfThreshold){
        //   this.state.pan.flattenOffset();
        //   this.props.onShelf()
        // }
        else {
          this.state.pan.flattenOffset();
          Animated.spring(this.state.pan, {
            toValue: { x: 0, y: 0 },
            friction: 10,
            useNativeDriver: !ENV.WEB,
          }).start(() => {});
        }

        setTimeout(() => {
          this.setState({ isDragging: false });
          let coords = { x: moveX, y: moveY };
          this.props.onDragEnd && this.props.onDragEnd(coords);
          if (this.props.global) {
            this.handleGlobalRelease(coords);
          }
        }, 0);
        // console.log('release', evt)
        // does nothing
        // evt.stopPropagation()
        // evt.preventDefault()
      },
      onPanResponderTerminate: (evt, gestureState) => {
        // Another component has become the responder, so this gesture
        // should be cancelled
        console.log("onPanResponderTerminate");
      },
      onShouldBlockNativeResponder: (evt, gestureState) => {
        // Returns whether this component should block native components from becoming the JS
        // responder. Returns true by default. Is currently only supported on android.
        return true;
      },
    });
    this.setState({ panResponder });
  }

  componentWillUnmount() {}

  render() {
    if (DISABLED || this.props.disabled) return this.props.children(false);

    let { isDragging } = this.state;
    let { flex } = this.props;
    // console.log(isDragging);
    return (
      <View style={[styles.container, flex && styles.flexContainer]}>
        {!!this.state.pan && !!this.state.panResponder ? (
          <Animated.View
            // useNativeDriver={true}
            style={[
              styles.circle,
              flex && styles.flexCircle,
              this.state.pan && {
                transform: [
                  { translateX: this.state.pan.x },
                  { translateY: this.state.pan.y },
                ],
              },
            ]}
            {...this.state.panResponder.panHandlers}
          >
            {this.props.children(isDragging)}
          </Animated.View>
        ) : (
          <View style={[styles.circle, { opacity: 0.6 }]}>
            {this.props.children(isDragging)}
          </View>
        )}
      </View>
    );
  }

  handleGlobalStart = async (coords) => {
    this.setState({ ...coords });
    store.dispatch({
      type: "dragging/set_dragging_item",
      draggingItem: this.props.item,
    });
  };

  handleGlobalMove = async (coords) => {
    let { dragging } = store.getState();
    let targets = dragging.targets;
    let previousId = dragging.overlappingId;
    let overlappingId = null;
    // console.log(previousId, coords, targets[0]);
    for (let target of targets) {
      let inspect = target.id == targets[0].id;
      let overlap = draggableHelpers.checkOverlap(coords, target, inspect);
      if (overlap) {
        // console.log("OVERLAP!", target);
        overlappingId = target.id;
        if (overlappingId != previousId) {
          // set new overlappingId
          store.dispatch({ type: "dragging/set_overlap_id", overlappingId });
        }
        break;
      }
    }
    if (overlappingId == null && !!previousId?.length) {
      // clear previous overlappingId
      console.log("CLEARING OVERLAP!");
      store.dispatch({ type: "dragging/set_overlap_id", overlappingId: null });
    }
    this.setState({ ...coords });
  };

  handleGlobalRelease = async (coords) => {
    let { dragging } = store.getState();
    let chapterId = dragging.overlappingChapterId;
    let valueId = dragging.overlappingValueId;
    let action = dragging.action;
    let draggingValueId = dragging.draggingItem?.value?.id;
    let allowDelete = false;
    if (action == "creat_moment") {
      if (!!chapterId && !!draggingValueId) {
        // allowDelete = true;
        // let res = await chapterActions.pinValue(chapterId, draggingValueId);
        if (dragging.metaKey) {
          // move moment to chapter
          let momentId = dragging.draggingItem.id;
          let res = await momentActions.update(momentId, {
            chapter_id: chapterId,
          });
          console.log(res);
        } else {
          // pin new moment
          let res = await chapterActions.pinValue(chapterId, draggingValueId);
        }
      } else {
        console.log(action, dragging);
        alert("action = creat_moment but no chapterId");
      }
    } else if (action == "add_child") {
      if (!!valueId && !!draggingValueId) {
        allowDelete = true;
        let res = await valueActions.addChild(valueId, draggingValueId);
      } else {
        console.log(action, dragging);
        alert("action = add_moment but no chapterId");
      }
    } else if (action == "sort_moments") {
      console.log(dragging);
      let momentId = dragging.draggingItem.id;
      let chapter = store.getState().chapters.find((c) => c.id == chapterId);
      let momentIds = chapter.moments.map((m) => m.id);
      let oldIndex = momentIds.indexOf(momentId);
      let newIndex = dragging.overlappingIndex;
      momentIds.splice(oldIndex, 1);
      momentIds.splice(newIndex, 0, momentId);
      let res = await chapterActions.sortMoments(chapterId, momentIds);
    } else if (action == "sort_children") {
      console.log(dragging);
      let value = store.getState().values.find((v) => v.id == valueId);
      let childIds = [...value.child_ids];
      let oldIndex = childIds.indexOf(draggingValueId);
      let newIndex = dragging.overlappingIndex;
      childIds.splice(oldIndex, 1);
      childIds.splice(newIndex, 0, draggingValueId);
      let res = await valueActions.update(valueId, { child_ids: childIds });
      // alert("whoops, drag&drop sorting children doesnt work yet");
    }
    if (allowDelete && dragging.metaKey) {
      let momentId = dragging.draggingItem?.id;
      if (momentId) {
        // let mRes = await momentActions.delete(momentId, false);
        alert("delete moment disabled");
      }
    }
    // clear values
    this.setState({ x: null, y: null });
    store.dispatch({ type: "dragging/end" });
    // store.dispatch({ type: "dragging/set_dragging_item", draggingItem: null });
    // store.dispatch({ type: "dragging/set_overlap_id", overlappingId: null });
    // store.dispatch({
    //   type: "dragging/set_overlap_chapter_id",
    //   overlappingChapterId: null,
    // });
    // store.dispatch({
    //   type: "dragging/set_overlap_value_id",
    //   overlappingValueId: null,
    // });
    // store.dispatch({
    //   type: "dragging/set_action",
    //   action: null,
    // });
    // store.dispatch({
    //   type: "dragging/set_action",
    //   overlappingIndex: null,
    // });
  };
}

let R = 60;

const styles = StyleSheet.create({
  container: {
    // alignSelf: 'stretch',
    // flexDirection: 'column',
    justifyContent: "center",
    alignItems: "center",
  },
  flexContainer: {
    // flex: 1,
    alignSelf: "stretch",
    alignItems: "stretch",
  },
  circle: {
    justifyContent: "center",
    alignItems: "center",
    // backgroundColor: "red",
    // borderWidth: 5,
    borderColor: colors.foreground,
    // width: R * 2,
    // height: R * 2,
    // borderRadius: R,
  },
  flexCircle: {
    // flex: 1,
    alignSelf: "stretch",
    alignItems: "stretch",
  },
});
